import React from 'react';
import { Card, Descriptions, Avatar, Typography, Divider, Row, Col, Tag } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, CalendarOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Profile = () => {
  // Get user data from localStorage
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Profil Pengguna</Title>

      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <Card>
            <div style={{ textAlign: 'center' }}>
              <Avatar
                size={120}
                icon={<UserOutlined />}
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  marginBottom: '16px'
                }}
              />
              <Title level={3} style={{ marginBottom: '8px' }}>
                {user?.full_name || user?.username || 'User'}
              </Title>
              <Tag color="blue" style={{ fontSize: '14px', padding: '4px 12px' }}>
                {user?.role?.replace('_', ' ')?.toUpperCase() || 'USER'}
              </Tag>
            </div>
          </Card>
        </Col>

        <Col xs={24} md={16}>
          <Card title="Informasi Sistem" style={{ marginBottom: '24px' }}>
            <Descriptions column={1} bordered>
              <Descriptions.Item
                label="Terakhir Login"
                labelStyle={{ fontWeight: 'bold', width: '200px' }}
              >
                <span>
                  <CalendarOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                  {new Date().toLocaleString('id-ID', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </span>
              </Descriptions.Item>

              <Descriptions.Item
                label="User ID"
                labelStyle={{ fontWeight: 'bold', width: '200px' }}
              >
                <Text code>{user?.id || '-'}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>

      <Divider />

      <Card title="Informasi Detail" style={{ marginBottom: '24px', width: '100%', overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <Descriptions
            column={{ xs: 1, sm: 2, md: 3, lg: 3 }}
            bordered
            layout="horizontal"
            colon={false}
            labelStyle={{
              fontWeight: 'bold',
              width: '180px',
              minWidth: '180px'
            }}
            contentStyle={{
              minWidth: '150px'
            }}
            style={{ minWidth: '600px' }}
          >
            <Descriptions.Item
              label="Username"
            >
              {user?.username || '-'}
            </Descriptions.Item>

            <Descriptions.Item
              label="Nama Lengkap"
            >
              {user?.full_name || '-'}
            </Descriptions.Item>

            <Descriptions.Item
              label="Email"
            >
              <span>
                <MailOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                {user?.email || '-'}
              </span>
            </Descriptions.Item>

            <Descriptions.Item
              label="No. Telepon"
            >
              <span>
                <PhoneOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                {user?.phone || '-'}
              </span>
            </Descriptions.Item>

            <Descriptions.Item
              label="Role"
            >
              <Tag color="green">
                {user?.role?.replace('_', ' ')?.toUpperCase() || 'USER'}
              </Tag>
            </Descriptions.Item>

            <Descriptions.Item
              label="Status"
            >
              <Tag color="success">Aktif</Tag>
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Card>
    </div>
  );
};

export default Profile;